import { toast } from '@systemeio/ui'
import { HeaderItemEditType } from 'modules/stores/store/content/header/types/header-interface'
import { useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { handle422Error } from 'shared/utils/parse-422-errors'
import { useStore } from '../../../hooks/use-store'
import { useStoreQuery } from '../../../hooks/use-store-query'
import { defaultErrors } from '../constants/default-values'
import { useActions } from './use-actions'

export const useEditHandler = () => {
  const { t } = useLocoTranslation()

  const { storeId } = useStoreQuery()
  const { mutate } = useStore(storeId)

  const [errors, setErrors] = useState(defaultErrors)
  const [isFetching, setIsFetching] = useState(false)

  const { createHeader, updateHeader } = useActions()

  const handleEdit = async ({ id, data }: { id?: number; data: HeaderItemEditType }) => {
    try {
      setIsFetching(true)
      setErrors(defaultErrors)

      if (id !== undefined) {
        const item = await updateHeader(id, data)

        await mutate(
          data =>
            data && {
              ...data,
              items: data.items.map(i => (i.itemId === item.itemId ? item : i)),
            },
          false,
        )
      } else if (storeId !== undefined) {
        const item = await createHeader(storeId, data)
        await mutate(data => data && { ...data, items: [...data.items, item] }, false)
      }

      toast.success(t('global.changes_saved'))
    } catch (e) {
      handle422Error(e, setErrors)
      throw e
    } finally {
      setIsFetching(false)
    }
  }

  return {
    isFetching,
    errors,
    handleEdit,
    setErrors,
  }
}
